var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fv-footer"},[_c('footer',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/framevuerk-builder/node_modules/pug-html-loader/lib!./node_modules/framevuerk-builder/node_modules/vue-loader/lib??vue-loader-options!./src/components/fvFooter.vue?vue&type=template&id=343501b4&lang=pug&
// module id = 95
// module chunks = 0 1